<template>
  <div class="form-wrapper">
    <div class="form-card">
      <div class="form-header">
        <h3 class="form-title">ข้อมูล Label</h3>
      </div>

      <div class="form-content">
        <el-form ref="formRef" :model="form" :rules="rules" @submit.native.prevent="handleSubmit">
          <div class="form-row">
            <div class="form-field">
              <el-form-item label="ชื่อภาษาไทย" prop="nameTh">
                <el-input v-model="form.nameTh" placeholder="ระบุชื่อภาษาไทย" maxlength="25" show-word-limit />
              </el-form-item>
            </div>

            <div class="form-field">
              <el-form-item label="ชื่อภาษาอังกฤษ" prop="nameEn">
                <el-input v-model="form.nameEn" placeholder="ระบุชื่อภาษาอังกฤษ" maxlength="25" show-word-limit />
              </el-form-item>
            </div>

            <div class="form-field">
              <el-form-item label="ชื่อภาษาจีน" prop="nameZh">
                <el-input v-model="form.nameZh" placeholder="ระบุชื่อภาษาจีน" maxlength="25" show-word-limit />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { labelValidationRules } from '../utils/labelValidation'

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: this.value,
      rules: labelValidationRules
    }
  },
  computed: {
    isFormValid() {
      return this.form.nameTh && this.form.nameTh.trim().length > 0
    }
  },
  watch: {
    value: {
      handler(newValue) {
        this.form = newValue
      },
      deep: true
    },
    'form.nameTh': {
      handler() {
        this.$emit('validation-change', this.isFormValid)
      },
      immediate: true
    }
  },
  mounted() {
    this.$emit('validation-change', this.isFormValid)
  },
  methods: {
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate()

        this.$emit('submit', { ...this.form })
      } catch {
        // Validation failed - form will show errors automatically
      }
    }
  }
}
</script>

<style lang="css" scoped>
/* Card Container */
.form-card {
  width: 100%;
  margin: 0 auto;
  background-color: white;
  border-radius: var(--size-sm);
  border: 1px solid #e5e7eb;
  overflow: hidden;
}

/* Header */
.form-header {
  background-color: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  padding: var(--size-md);
}

.form-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #374151;
}

/* Content */
.form-content {
  padding: var(--size-lg);
}

/* Form Layout */
.form-row {
  display: flex;
  gap: var(--size-lg);
  margin-bottom: var(--size-lg);
  width: 100%;
  flex-wrap: nowrap !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.form-field {
  flex: 1;
  min-width: 0;
  width: 100%;
}

/* Form Item Styles */
.form-field .el-form-item {
  margin-bottom: 0;
}

.form-field .el-form-item__label {
  font-weight: 500;
  color: #374151;
  line-height: 1.5;
  margin-bottom: var(--size-xs);
}

.form-field .el-input {
  width: 100%;
}

.form-field .el-input__inner {
  border-radius: var(--size-xs);
  border: 1px solid #d1d5db;
  transition: all 0.3s ease;
}

.form-field .el-input__inner:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* Move required asterisk from before to after label */
.form-field .el-form-item.is-required .el-form-item__label:before {
  content: none !important;
}

.form-field .el-form-item.is-required .el-form-item__label:after {
  content: ' *';
  color: #f56c6c;
  margin-left: 2px;
}

/* Responsive Design */
@media screen and (max-width: 1024px) {
  .form-row {
    flex-direction: column !important;
    flex-wrap: nowrap !important;
    gap: var(--size-sm);
    margin-right: 0 !important;
    margin-left: 0 !important;
  }

  .form-field {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .form-card {
    max-width: 100%;
  }

  .form-header,
  .form-content {
    padding: var(--size-md);
  }

  .form-title {
    font-size: 0.875rem;
  }
}

@media screen and (max-width: 480px) {

  .form-header,
  .form-content {
    padding: var(--size-sm);
  }

  .form-title {
    font-size: 0.75rem;
  }
}
</style>
